var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6020_11599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.059V13H5.628L0 9.059ZM4.664 31H13V25.163L4.664 31ZM23 25.164V31H31.335L23 25.164ZM0 23V26.941L5.63 23H0ZM31.337 5H23V10.837L31.337 5ZM36 26.942V23H30.369L36 26.942ZM36 13V9.059L30.371 13H36ZM13 5H4.664L13 10.837V5Z",
    fill: "#003192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1402 23L34.8522 29.801C35.3265 29.3124 35.6674 28.7101 35.8422 28.052L28.6272 23H25.1402ZM13.0002 23H10.8592L1.14823 29.8C1.66923 30.33 2.33723 30.709 3.08623 30.885L13.0002 23.943V23ZM23.0002 13H25.1412L34.8522 6.19999C34.3223 5.66227 33.6506 5.28602 32.9152 5.11499L23.0002 12.057V13ZM10.8592 13L1.14823 6.19999C0.67418 6.68896 0.333041 7.29103 0.157227 7.94899L7.37223 13H10.8592Z",
    fill: "#F52933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 21H21V31H23V25.164L31.335 31H32C32.5313 31.0001 33.0572 30.8941 33.5469 30.6882C34.0367 30.4823 34.4804 30.1807 34.852 29.801L25.14 23H28.627L35.842 28.052C35.935 27.715 36 27.366 36 27V26.942L30.369 23H36V21ZM0 21V23H5.63L0 26.941V27C0 28.091 0.439 29.078 1.148 29.8L10.859 23H13V23.943L3.086 30.884C3.38 30.954 3.684 31 4 31H4.664L13 25.163V31H15V21H0ZM36 9C36.0006 7.95198 35.5881 6.94595 34.852 6.2L25.141 13H23V12.057L32.915 5.115C32.6155 5.04153 32.3084 5.00294 32 5H31.337L23 10.837V5H21V15H36V13H30.371L36 9.059V9ZM13 5V10.837L4.664 5H4C3.46862 4.99977 2.94257 5.10581 2.45278 5.3119C1.96299 5.51798 1.51936 5.81993 1.148 6.2L10.859 13H7.372L0.157 7.949C0.0577802 8.29071 0.00497341 8.64421 0 9L0 9.059L5.628 13H0V15H15V5H13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15V5H15V15H0V21H15V31H21V21H36V15H21Z",
    fill: "#F52933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6020_11599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.d871e3ec.svg";
export { ForwardRef as ReactComponent };